import styled, { css } from 'styled-components'
import { ITileFormColumnProps } from './@types/ITileFormColumn.props'

export const TileFormColumn = styled.div<ITileFormColumnProps>(
  ({
    width, align, justify, padding, textAlign, comparedLocation,
  }) => css`
    width: ${width || '100%'};
    display: flex;
    align-items: ${align};
    justify-content: ${justify};
    text-align: ${textAlign};
    padding: ${padding};
    flex-direction: column;
    flex-wrap: nowrap;

    > div {
      margin-left: 0.25rem;
      margin-right: 0.25rem;
      ${comparedLocation && css`
        margin:0;
      `}
    }

    > div:first-child {
      margin-left: 0;
    }

    > div:last-child {
      margin-right: 0;
    }
  `,
)
